module.exports = __webpack_public_path__ + "img/gift2.9066730f.png";